// -----------------------APPEARANCE-----------------------
export var DNAChipAppearanceEnum;
(function (DNAChipAppearanceEnum) {
    DNAChipAppearanceEnum["filled"] = "filled";
    DNAChipAppearanceEnum["subtle"] = "subtle";
    DNAChipAppearanceEnum["outline"] = "outline";
})(DNAChipAppearanceEnum || (DNAChipAppearanceEnum = {}));
export const DNAChipAppearanceKeys = Object.keys(DNAChipAppearanceEnum);
// --------------------------STATUS--------------------------
export var DNAChipStatusEnum;
(function (DNAChipStatusEnum) {
    DNAChipStatusEnum["primary"] = "primary";
    DNAChipStatusEnum["secondary"] = "secondary";
    DNAChipStatusEnum["success"] = "success";
    DNAChipStatusEnum["warning"] = "warning";
    DNAChipStatusEnum["danger"] = "danger";
    DNAChipStatusEnum["transparent"] = "transparent";
    DNAChipStatusEnum["white"] = "white";
})(DNAChipStatusEnum || (DNAChipStatusEnum = {}));
export const DNAChipStatusKeys = Object.keys(DNAChipStatusEnum);
// --------------------------SIZE--------------------------
export var DNAChipSizeEnum;
(function (DNAChipSizeEnum) {
    DNAChipSizeEnum["sm"] = "sm";
    DNAChipSizeEnum["md"] = "md";
    DNAChipSizeEnum["lg"] = "lg";
})(DNAChipSizeEnum || (DNAChipSizeEnum = {}));
export const DNAChipSizeKeys = Object.keys(DNAChipSizeEnum);
//# sourceMappingURL=DNAChip.types.js.map